import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export * from './demo-cluster-fixtures';
export * from './modifiers';
export type * from './types';
// Note: io/browser.ts uses import.meta.glob which is Vite-specific
// Import browser loader directly: import { makeLoader } from '@cast/fixtures/io'
export * from './generators/services-health';
export * from './generators/cluster-management-cluster-components';
export * from './generators/cluster-management-clusters-components';
export * from './generators/cluster-management-component';
export * from './generators/cluster-management-components';
export * from './generators/cluster-management-features';
export * from './generators/cluster-management-component-status';
export * from './generators/cluster-management-run-action';
export * from './generators/cluster-hibernation-schedules-list';
export * from './generators/security-insights-vulnerabilities-trend-json';
export * from './factories';
export * from './utils/available-savings-nodes';
export * from './generators/cluster-storage-summary-json';
export * from './generators/storage-actions-json';
export * from './generators/storage-summary-json';
export * from './generators/storage-metrics-json';
export * from './generators/persistent-volumes-list-json';
export * from './generators/persistent-volumes-summary-json';
export * from './generators/persistent-volumes-details-json';
